<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  competitor: {
    type: Object,
    required: true,
  }
})

const hasError = ref(false);

const url = computed(() => `https://logo.clearbit.com/${props.competitor.simpleUrl}`)

</script>

<template>
  <div class="tw-flex tw-items-center tw-justify-center">
    <img
      v-show="!hasError"
      :src="url"
      :alt="`${competitor.name} Logo`"
      :onerror="() => hasError = true"
      class="tw-max-h-full tw-max-w-full"
    >
    <svg-vue
      v-show="hasError"
      icon="icons/placeholder"
      class="tw-max-h-full tw-max-w-full"
    />
  </div>
</template>